module.exports = function() {
  return new Worker(__webpack_public_path__ + "7cda4adc68ca80cffc71.worker.js");
};